import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export function StatCard(t0) {
  const $ = _c(13);
  const {
    num,
    label,
    hint,
    hero: t1,
    dim: t2
  } = t0;
  const hero = t1 === undefined ? false : t1;
  const dim = t2 === undefined ? false : t2;
  const cls = hero ? dim ? "stat-card stat-card--hero-dim" : "stat-card stat-card--hero" : "stat-card";
  const t3 = dim || undefined;
  let t4;
  if ($[0] !== num) {
    t4 = <div className="stat-card__num">{num}</div>;
    $[0] = num;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== label) {
    t5 = <div className="stat-card__label">{label}</div>;
    $[2] = label;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== hint) {
    t6 = hint && <div className="stat-card__hint">{hint}</div>;
    $[4] = hint;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== cls || $[7] !== hero || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <div data-hero={hero} data-dim={t3} className={cls}>{t4}{t5}{t6}</div>;
    $[6] = cls;
    $[7] = hero;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}